import React, { useEffect, useState } from 'react'
import VehicleModel from './models/VehicleModel';

function ViewVehicle(props) {
  const [vehicleData, setVehicleData] = useState(new VehicleModel());

  useEffect(() => {
    setVehicleData(props.VehicleData);
  }, [props.VehicleData])

  return (
    <>
      <div className="row">
        <div className="col-lg-6">
          <div className="mb-3 add-product">
            <label className="form-label">Vehicle Type</label>
            <input type="text" className="form-control" value={vehicleData.VehicleType} disabled />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="mb-3 add-product">
            <label className="form-label">Manufacturer</label>
            <input type="text" className="form-control" value={vehicleData.Manufacturer} disabled />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-6">
          <div className="mb-3 add-product">
            <label className="form-label">Model Name</label>
            <input type="text" className="form-control" value={vehicleData.ModelName} disabled />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="mb-3 add-product">
            <label className="form-label">Variant</label>
            <input type="text" className="form-control" value={vehicleData.Variant} disabled />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-6">
          <div className="mb-3 add-product">
            <label className="form-label">Segment</label>
            <input type="text" className="form-control" value={vehicleData.Segment} disabled />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="mb-3 add-product">
            <label className="form-label">Color</label>
            <input type="text" className="form-control" value={vehicleData.Color} disabled />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-6">
          <div className="mb-3 add-product">
            <label className="form-label">Fuel Type</label>
            <input type="text" className="form-control" value={vehicleData.FuelType} disabled />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="mb-3 add-product">
            <label className="form-label">Engine CC</label>
            <input type="text" className="form-control" value={vehicleData.EngineCC} disabled />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-6">
          <div className="mb-3 add-product">
            <label className="form-label">Launch Date</label>
            <input type="text" className="form-control" value={vehicleData.LaunchDate} disabled />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="mb-3 add-product">
            <label className="form-label">Discontinue Date</label>
            <input type="text" className="form-control" value={vehicleData.DiscontinueDate} disabled />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-6">
          <div className="mb-3 add-product">
            <label className="form-label">Status</label>
            <input type="text" className="form-control" value={vehicleData.Status} disabled />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12">
          <div className="mb-3 add-product">
            <label className="form-label">Remarks</label>
            <textarea className="form-control" rows="2" value={vehicleData.Remarks} disabled />
          </div>
        </div>
      </div>
    </>
  )
}

export default ViewVehicle
